import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { Modal, ModalBody } from '@/components/atoms/modal'
import { centeredModalStyle } from './card-key-modal-style'

type Props = {
  message: string
  onClose: () => void
}

export const CardKeyReadErrorModal: React.FC<Props> = ({ message, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal customCss={centeredModalStyle(510)}>
      <img src={require('@/static/images/miwa-lock/miwa_card_read_close.svg')} css={closeIconStyle} alt={t('Close')} onClick={onClose} />
      <ModalBody customCss={{ backgroundColor: '#fff', padding: '40px 32px' }}>
        {/* 文言は i18n 定数由来のみ（toMiwaAppErrorMessage 等）で、改行の <br /> を含むため既存の発行結果モーダルと同じく HTML として描画する */}
        <p css={messageStyle} dangerouslySetInnerHTML={{ __html: message }} />
        <img src={require('@/static/images/miwa-lock/miwa_card_read_error.svg')} css={imageStyle} alt="" />
      </ModalBody>
    </Modal>
  )
}

// デザイン上、閉じるアイコンはモーダルの右上外側（背景の暗幕の上）に置く
const closeIconStyle = css({
  position: 'absolute',
  top: -43,
  right: -70,
  width: 60,
  height: 60,
  cursor: 'pointer',
})

const messageStyle = css({
  color: '#272727',
  fontSize: 18,
  fontWeight: 'bold',
  textAlign: 'center',
  marginBottom: 16,
})

const imageStyle = css({
  display: 'block',
  margin: '0 auto',
  width: 201,
})
